module.exports = __webpack_public_path__ + "static/media/bg-fat-analysis-waist-hip-ratio.c864d52c.png";